import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
export const ALL_RESULTS_QUERY_KEY = 'all_results';
export const BACKGROUND_ENTRIES_QUERY_KEY = 'background_entries';
export const PAGINATION_STATE_QUERY_KEY = 'thread_pagination_state';
export const FIRST_ENTRY_QUERY_KEY = 'thread_first_entry';
export const LATEST_ENTRY_QUERY_KEY = 'thread_latest_entry';
export const INITIAL_PAGINATED_FETCH_SIZE = 20;
export const PAGINATED_FETCH_SIZE = 100;
// The backend paginates foreground and background entries together, then splits them, so a
// valid page can contain only subagent/background entries. Follow a bounded number of those
// pages before handing control back to the caller.
export const MAX_CONSECUTIVE_BACKGROUND_ONLY_PAGES = 10;
const PAGINATED_QUERY_KEY = 'paginated';
export function isEmptyThreadPage(page) {
    return !page?.entries?.length && !page?.background_entries?.length;
}
export function getAllResultsQueryKey(slugOrUUID, paginationPosition) {
    return paginationPosition
        ? QueryClientHelper.makeQueryKey(ALL_RESULTS_QUERY_KEY, slugOrUUID, PAGINATED_QUERY_KEY, paginationPosition)
        : QueryClientHelper.makeQueryKey(ALL_RESULTS_QUERY_KEY, slugOrUUID);
}
export function getBackgroundEntriesQueryKey(slugOrUUID, paginationPosition) {
    return paginationPosition
        ? QueryClientHelper.makeQueryKey(BACKGROUND_ENTRIES_QUERY_KEY, slugOrUUID, PAGINATED_QUERY_KEY, paginationPosition)
        : QueryClientHelper.makeQueryKey(BACKGROUND_ENTRIES_QUERY_KEY, slugOrUUID);
}
export function getPaginationStateQueryKey(slugOrUUID, position) {
    return QueryClientHelper.makeQueryKey(PAGINATION_STATE_QUERY_KEY, slugOrUUID, position);
}
export function getFirstEntryQueryKey(slugOrUUID) {
    return QueryClientHelper.makeQueryKey(FIRST_ENTRY_QUERY_KEY, slugOrUUID);
}
export function getLatestEntryQueryKey(slugOrUUID) {
    return QueryClientHelper.makeQueryKey(LATEST_ENTRY_QUERY_KEY, slugOrUUID);
}
export function mergeThreadPage(current, page, { position, boundaryEntryUuid, }) {
    const pageEntryUuids = new Set(page.map((entry) => entry.backend_uuid));
    const remaining = (current ?? []).filter((entry) => !pageEntryUuids.has(entry.backend_uuid));
    if (position === 'start')
        return [...page, ...remaining];
    const boundaryIndex = boundaryEntryUuid
        ? remaining.findIndex((entry) => entry.backend_uuid === boundaryEntryUuid)
        : -1;
    const insertionIndex = boundaryIndex < 0 ? remaining.length : boundaryIndex + 1;
    return [...remaining.slice(0, insertionIndex), ...page, ...remaining.slice(insertionIndex)];
}
//# sourceMappingURL=threadPagination.js.map